import BaseModel from './BaseModel'
import Link from './Link'
import { ActionCard } from './ActionCard'

export class PaymentPlans extends BaseModel {
  current: ActionCard[]
  defaultText: string
  links: Link[]

  setLinks (a?: []) {
    return a ? a.map(aa => new Link().init(aa)) : []
  }
}
